module.exports = __webpack_public_path__ + "static/media/alerta-documentacion-auto-verde.eea6df8d.svg";